export default __webpack_public_path__ + "static/media/Brett_Martinez.aebf7573.jpg";